export default __webpack_public_path__ + "static/media/googlepay_qr.1fab63b4.jpg";